<template>    
    <v-snackbar :timeout="timeout" :class="color" v-model="display">
       {{ message }}
    </v-snackbar>
</template>

<style lang="stylus">
.snack__content {
    max-width: none;
}
</style>

<script>
import { mapGetters } from 'vuex';
import constants from '@/helpers/constants';

export default {
    data: () => ({
        timeout: 10000,
    }),
    computed: {
        ...mapGetters(['event']),
        display: {
            get() {
                return this.event.display;
            },
            set() {
                this.$store.dispatch('hideEvent');
            },
        },
        message() {
            return this.event.message;
        },
        color() {
            const hash = {
                [constants.EVENT_SUCCESS]: 'success',
                [constants.EVENT_INFO]: 'primary',
                [constants.EVENT_WARNING]: 'warning',
                [constants.EVENT_ERROR]: 'error',
            };
            return hash[this.event.type];
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Event.vue